import styled from '@emotion/styled';
import { theme } from '../../theme';
import { IconButton } from '../icon-button';
import { Pictogram } from '../pictogram';
export const Container = styled.div `
	height: 264px;
	display: flex;
	flex-direction: column;
`;
export const PictureContainer = styled.div `
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;

	padding: ${({ size, hasFooter }) => {
    const topAndSidePadding = size === 'small' ? theme.spacing.space40 : theme.spacing.space50;
    const bottomPadding = hasFooter
        ? theme.spacing.space40
        : topAndSidePadding;
    return `${topAndSidePadding} ${topAndSidePadding} ${bottomPadding} ${topAndSidePadding}`;
}};

	${({ url }) => {
    if (!url)
        return `background: ${theme.colors.LM_NU100}`;
    return {
        background: `linear-gradient(to top, ${theme.colors.LM_NU100}, rgba(17,35,58,0.5)), url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    };
}};
`;
export const StyledPictogram = styled(Pictogram) `
	position: absolute;
	opacity: 0.5;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);

	opacity: 0.25;
`;
export const Header = styled.div `
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;
export const PropertyNicknameEditContainer = styled.div `
	display: flex;
	flex-direction: row;
	gap: ${theme.spacing.space20};
	align-items: center;

	/* Child text should be able to overflow */
	min-width: 0;
`;
export const PropertyNickname = styled.h2 `
	${theme.typography.IB130};
	color: ${theme.colors.LM_NU0};
	margin: 0;

	/* Allow text to wrap*/
	overflow: hidden;
	white-space: normal;
	word-wrap: break-word;

	/* Ensure the container does not expand beyond its parent */
	mid-width: 0;
	flex-grow: 1;
`;
export const ButtonContainer = styled.div `
	display: flex;
	align-self: flex-end;
`;
export const EditButton = styled(IconButton) `
	color: ${theme.colors.LM_NU0};
`;
export const ChipContainer = styled.div `
	display: flex;
	align-self: flex-end;
	padding-bottom: 6px;
`;
export const Footer = styled.div `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	padding: ${({ size }) => {
    const padding = size === 'small' ? theme.spacing.space40 : theme.spacing.space50;
    return `0 ${padding} ${padding} ${padding}`;
}};

	color: ${theme.colors.LM_NU0};
	background-color: ${theme.colors.LM_NU100};
	${theme.typography.IR90};
`;
export const PropertyScoreContainer = styled.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${theme.spacing.space20};
`;
export const PropertyScoreValuesContainer = styled.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${theme.spacing.space20};
`;
export const RatingContainer = styled.div `
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: ${theme.spacing.space20};
`;
//# sourceMappingURL=PropertyHeader.styled.js.map